import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  excelCellValidationErrors: {},
  openCriticalityDropdownRowId: null,
  selectedRowIndex: 0,
  lastSelectedRowIndex: null,
};

export const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setExcelCellValidationErrors: (state, { payload }) => {
      state.excelCellValidationErrors = payload || {};
    },
    setOpenCriticalityDropdownRowId: (state, { payload }) => {
      state.openCriticalityDropdownRowId = payload;
    },
    clearCriticalityDropdownForRow: (state, { payload }) => {
      if (state.openCriticalityDropdownRowId === payload) {
        state.openCriticalityDropdownRowId = null;
      }
    },
    setSelectedRowIndex: (state, action) => {
      state.lastSelectedRowIndex = state.selectedRowIndex;

      state.selectedRowIndex = action.payload ?? 0;
    },
    setLastSelectedRowIndex: (state, action) => {
      state.lastSelectedRowIndex = action.payload;
    },
    resetTableState: () => {
      return initialState;
    },
  },
});

export const {
  setExcelCellValidationErrors,
  setOpenCriticalityDropdownRowId,
  clearCriticalityDropdownForRow,
  setLastSelectedRowIndex,
  setSelectedRowIndex,
  resetTableState,
} = tableSlice.actions;

export default tableSlice.reducer;
